"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ToolbarStateChangedEvent {
    constructor(_canRedo, _canUndo) {
        this._canRedo = _canRedo;
        this._canUndo = _canUndo;
    }
    get canRedo() {
        return this._canRedo;
    }
    get canUndo() {
        return this._canUndo;
    }
}
exports.ToolbarStateChangedEvent = ToolbarStateChangedEvent;
//# sourceMappingURL=ToolbarStateChangedEvent.js.map